<!-- 选择性别 -->
<template>
  <el-form-item :label="label">
    <el-select v-model="sexList" placeholder="请选择" multiple clearable
     collapse-tags-tooltip fit-input-width :collapse-tags="true" :max-collapse-tags="1">
        <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in sexOptionList"></el-option>
      </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-学员性别',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ([]),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '学员：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const sexOptionList = ref([{ id: 2, name: '未知' }, { id: 1, name: '男' }, { id: 0, name: '女' }]);
    const sexList = useQuery('sexList', props.value);
    return {
      sexList,
      sexOptionList,
    };
  },
};
</script>
